import React, { createElement } from 'react';
import { Button } from '../components/ui/Button';
import { Download } from 'lucide-react';
const svgColorStacked = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 160" width="100%" height="100%">
  <g transform="translate(120, 50)">
    <rect x="-24" y="-36" width="48" height="48" rx="10" fill="#0d9488" />
    <text x="0" y="-2" font-family="system-ui, -apple-system, sans-serif" font-size="28" font-weight="800" fill="#ffffff" text-anchor="middle">D</text>
  </g>
  <text x="120" y="95" font-family="system-ui, -apple-system, sans-serif" font-size="32" font-weight="800" text-anchor="middle" letter-spacing="-0.02em">
    <tspan fill="#111827">Dentico</tspan><tspan fill="#0d9488">Clinic</tspan>
  </text>
  <text x="120" y="120" font-family="system-ui, -apple-system, sans-serif" font-size="11" font-weight="600" fill="#6b7280" letter-spacing="0.25em" text-anchor="middle">PRIVATE DENTISTRY</text>
</svg>`;
const svgWhiteStacked = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 160" width="100%" height="100%">
  <g transform="translate(120, 50)">
    <rect x="-24" y="-36" width="48" height="48" rx="10" fill="#ffffff" />
    <text x="0" y="-2" font-family="system-ui, -apple-system, sans-serif" font-size="28" font-weight="800" fill="#111827" text-anchor="middle">D</text>
  </g>
  <text x="120" y="95" font-family="system-ui, -apple-system, sans-serif" font-size="32" font-weight="800" fill="#ffffff" text-anchor="middle" letter-spacing="-0.02em">DenticoClinic</text>
  <text x="120" y="120" font-family="system-ui, -apple-system, sans-serif" font-size="11" font-weight="600" fill="rgba(255,255,255,0.8)" letter-spacing="0.25em" text-anchor="middle">PRIVATE DENTISTRY</text>
</svg>`;
const svgDarkStacked = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 160" width="100%" height="100%">
  <g transform="translate(120, 50)">
    <rect x="-24" y="-36" width="48" height="48" rx="10" fill="#111827" />
    <text x="0" y="-2" font-family="system-ui, -apple-system, sans-serif" font-size="28" font-weight="800" fill="#ffffff" text-anchor="middle">D</text>
  </g>
  <text x="120" y="95" font-family="system-ui, -apple-system, sans-serif" font-size="32" font-weight="800" fill="#111827" text-anchor="middle" letter-spacing="-0.02em">DenticoClinic</text>
  <text x="120" y="120" font-family="system-ui, -apple-system, sans-serif" font-size="11" font-weight="600" fill="#6b7280" letter-spacing="0.25em" text-anchor="middle">PRIVATE DENTISTRY</text>
</svg>`;
const svgIconOnly = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%">
  <rect x="10" y="10" width="80" height="80" rx="16" fill="#0d9488" />
  <text x="50" y="66" font-family="system-ui, -apple-system, sans-serif" font-size="48" font-weight="800" fill="#ffffff" text-anchor="middle">D</text>
</svg>`;
const svgHorizontal = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 100" width="100%" height="100%">
  <g transform="translate(20, 50)">
    <rect x="0" y="-24" width="48" height="48" rx="10" fill="#0d9488" />
    <text x="24" y="10" font-family="system-ui, -apple-system, sans-serif" font-size="28" font-weight="800" fill="#ffffff" text-anchor="middle">D</text>
  </g>
  <text x="85" y="48" font-family="system-ui, -apple-system, sans-serif" font-size="32" font-weight="800" text-anchor="start" letter-spacing="-0.02em">
    <tspan fill="#111827">Dentico</tspan><tspan fill="#0d9488">Clinic</tspan>
  </text>
  <text x="87" y="70" font-family="system-ui, -apple-system, sans-serif" font-size="11" font-weight="600" fill="#6b7280" letter-spacing="0.25em" text-anchor="start">PRIVATE DENTISTRY</text>
</svg>`;
export function LogoPage() {
  const downloadSvg = (svgString: string, filename: string) => {
    const blob = new Blob([svgString], {
      type: 'image/svg+xml;charset=utf-8'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  return <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-id="element-2553" data-mp="1l6vs6qopa9sb">
      <div className="max-w-5xl mx-auto" data-id="element-2554" data-mp="1h5trs6j1rror">
        {/* Header */}
        <div className="mb-12 text-center" data-id="element-2555" data-mp="1h48u481frsmo">
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-2556" data-mp="1c81qilwiit7w">
            Dentico Clinic — Logo Kit
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-2557" data-mp="28w825sruqlvo">
            Download logos for websites, business cards, and print materials.
            All files are provided in vector SVG format for infinite
            scalability.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2558" data-mp="1uwotmyv4p8iu">
          {/* Variant 1: Full Color */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col" data-id="element-2559" data-mp="oiplzzc4r9bx">
            <div className="h-64 bg-white flex items-center justify-center p-8 border-b border-gray-100 relative" data-id="element-2560" data-mp="jh06a6dyq7hi">
              <div className="absolute top-4 left-4 text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-2561" data-mp="9gh9xzqz3jy4">
                Preview
              </div>
              <div className="w-full h-full" dangerouslySetInnerHTML={{
              __html: svgColorStacked
            }} data-id="element-2562" data-mp="jckbb3e03ek0" />
            </div>
            <div className="p-6 flex items-center justify-between bg-gray-50/50 flex-1" data-id="element-2563" data-mp="s5xdyx1v9uja">
              <div data-id="element-2564" data-mp="x3pf8hoeit05">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-2565" data-mp="x2xllced75ci">
                  Full Color
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2566" data-mp="1243fvenob0o5">Standard stacked layout</p>
              </div>
              <Button onClick={() => downloadSvg(svgColorStacked, 'dentico-logo-color.svg')} className="gap-2" data-id="element-2567" data-mp="171n5faptmzve">
                <Download className="w-4 h-4" data-id="element-2568" data-mp="38ub9tne7btcr" />
                Download SVG
              </Button>
            </div>
          </div>

          {/* Variant 2: White on Dark */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col" data-id="element-2569" data-mp="2vv26tmal65sq">
            <div className="h-64 bg-[#1a1a2e] flex items-center justify-center p-8 border-b border-gray-100 relative" data-id="element-2570" data-mp="3as18ktirb4fa">
              <div className="absolute top-4 left-4 text-xs font-medium text-white/40 uppercase tracking-wider" data-id="element-2571" data-mp="35qvfgul6pf58">
                Preview
              </div>
              <div className="w-full h-full" dangerouslySetInnerHTML={{
              __html: svgWhiteStacked
            }} data-id="element-2572" data-mp="3etms2xpsqgyg" />
            </div>
            <div className="p-6 flex items-center justify-between bg-gray-50/50 flex-1" data-id="element-2573" data-mp="3oiei30baqr6q">
              <div data-id="element-2574" data-mp="6cjoeoq5hhpj">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-2575" data-mp="6e31k6gifcn3">White</h3>
                <p className="text-sm text-gray-500" data-id="element-2576" data-mp="2bzpbfm0o40r">For dark backgrounds</p>
              </div>
              <Button onClick={() => downloadSvg(svgWhiteStacked, 'dentico-logo-white.svg')} className="gap-2" data-id="element-2577" data-mp="kz8mqn8o1ouc">
                <Download className="w-4 h-4" data-id="element-2578" data-mp="bzli7skn42x2" />
                Download SVG
              </Button>
            </div>
          </div>

          {/* Variant 3: Dark Mono */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col" data-id="element-2579" data-mp="gzzrfdxz9iwo">
            <div className="h-64 bg-white flex items-center justify-center p-8 border-b border-gray-100 relative" data-id="element-2580" data-mp="6zz5rlcmyqpb">
              <div className="absolute top-4 left-4 text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-2581" data-mp="3pei5bwalnso7">
                Preview
              </div>
              <div className="w-full h-full" dangerouslySetInnerHTML={{
              __html: svgDarkStacked
            }} data-id="element-2582" data-mp="3tdh6r6x4h7aw" />
            </div>
            <div className="p-6 flex items-center justify-between bg-gray-50/50 flex-1" data-id="element-2583" data-mp="3kgyg61cd5vhh">
              <div data-id="element-2584" data-mp="3qptd9c6otyl">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-2585" data-mp="3p4z7kts7d19">
                  Dark Mono
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2586" data-mp="3qvyl1vtkc2a8">For light backgrounds</p>
              </div>
              <Button onClick={() => downloadSvg(svgDarkStacked, 'dentico-logo-dark.svg')} className="gap-2" data-id="element-2587" data-mp="3lxdwwurl5925">
                <Download className="w-4 h-4" data-id="element-2588" data-mp="3c7avq7ab8osq" />
                Download SVG
              </Button>
            </div>
          </div>

          {/* Variant 5: Horizontal */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col" data-id="element-2589" data-mp="378heq4vtefnt">
            <div className="h-64 bg-white flex items-center justify-center p-8 border-b border-gray-100 relative" data-id="element-2590" data-mp="334t6djzczg1i">
              <div className="absolute top-4 left-4 text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-2591" data-mp="2t8ghr0io7sdm">
                Preview
              </div>
              <div className="w-full h-full flex items-center" dangerouslySetInnerHTML={{
              __html: svgHorizontal
            }} data-id="element-2592" data-mp="18pw2d2ljeyxs" />
            </div>
            <div className="p-6 flex items-center justify-between bg-gray-50/50 flex-1" data-id="element-2593" data-mp="1imh9pul14m4s">
              <div data-id="element-2594" data-mp="1mpdy61x93cgn">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-2595" data-mp="1mnugc6vy4tcr">
                  Horizontal
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2596" data-mp="uyrboq05dgzl">For headers and navbars</p>
              </div>
              <Button onClick={() => downloadSvg(svgHorizontal, 'dentico-logo-horizontal.svg')} className="gap-2" data-id="element-2597" data-mp="z0uobhyjyrmg">
                <Download className="w-4 h-4" data-id="element-2598" data-mp="79ojwpbsu7rd" />
                Download SVG
              </Button>
            </div>
          </div>

          {/* Variant 4: Icon Only (Full Width) */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col md:col-span-2" data-id="element-2599" data-mp="b8nqeed6ickx">
            <div className="h-64 flex border-b border-gray-100 relative" data-id="element-2600" data-mp="12aoe7vawq9k8">
              <div className="absolute top-4 left-4 text-xs font-medium text-gray-400 uppercase tracking-wider z-10" data-id="element-2601" data-mp="16crtyw4m00bb">
                Preview
              </div>
              {/* Light side */}
              <div className="w-1/2 bg-white flex items-center justify-center p-8" data-id="element-2602" data-mp="1b9i6j9h7gdrz">
                <div className="w-32 h-32" dangerouslySetInnerHTML={{
                __html: svgIconOnly
              }} data-id="element-2603" data-mp="ejircw6juh0f" />
              </div>
              {/* Dark side */}
              <div className="w-1/2 bg-[#1a1a2e] flex items-center justify-center p-8" data-id="element-2604" data-mp="sdjsfwkz4g3y">
                <div className="w-32 h-32" dangerouslySetInnerHTML={{
                __html: svgIconOnly
              }} data-id="element-2605" data-mp="3r3a51g6nat7w" />
              </div>
            </div>
            <div className="p-6 flex items-center justify-between bg-gray-50/50" data-id="element-2606" data-mp="3oiuc9o8q31n8">
              <div data-id="element-2607" data-mp="3jizklih4i814">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-2608" data-mp="3jkj0v92s4j2w">
                  Icon Only
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2609" data-mp="3eitnvnvzxvc6">
                  For avatars, favicons, and social media
                </p>
              </div>
              <Button onClick={() => downloadSvg(svgIconOnly, 'dentico-icon.svg')} className="gap-2" data-id="element-2610" data-mp="35jge0u3yn4qx">
                <Download className="w-4 h-4" data-id="element-2611" data-mp="30rf6flhqm278" />
                Download SVG
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}